export default {
  data() {
    return {
      back: false,
      state: [],
      step: 0,
      storedQuestionnaireId: null,
    };
  },
  computed: {
    clippedQuestions() {
      return this.state.slice(this.step - 1, this.step + 2).map((state) => {
        if (['start', 'end', 'completed'].includes(state.questionId)) {
          return { id: state.questionId };
        } else {
          return this.$store.getters['flashcards/flashcards'][state.questionId];
        }
      });
    },
    questionnaireUserState() {
      // just using first questionnaire state
      return this.$store.getters['questionnaireUserStates/all'].find(
        (s) => s.questionnaireId == this.questionnaireId,
      );
    },
    startedQuestionnaire() {
      return !!(this.questionnaireUserState) || this.step > 0;
    },
  },
  methods: {
    handleDateAnswer(question, date) {
      let params = {};
      const day = Math.max(date.day, 1);
      // convert date to YYYY-MM-DD format
      params[question.id] = `${date.year}-${date.month}-${day}`;
      return params;
    },
    handleQuestionAnswer(question, answers) {
      const allowedAnswers = question.answers.filter((a) => a.correct).length;
      const params = {};
      const data = allowedAnswers === 1
        ? answers[0].text
        : answers.map((a) => a.text);
      params[question.id] = data;
      return params;
    },
    resetState() {
      this.back = false;
      this.state = [];
      this.step = 0;
      this.storedQuestionnaireId = null;
    },
    restoreLastState() {
      const data = {};
      if (this.questionnaireUserState.state) {
        const last = this.questionnaireUserState.state.sort(
          (a, b) => b.timestamp - a.timestamp,
        )[0];
        data[last.questionId] = last.response;
      }
      return data;
    },
    setInitialState() {
      this.state = [
        { questionId: 'start' },
        ...(this.questionnaireUserState.state || []).sort(
          (a, b) => a.timestamp - b.timestamp,
        ),
        { questionId: this.questionnaireUserState.lastDeliveredQuestionId },
        { questionId: 'end' },
      ];
    },
    updateStep(step) {
      if (step) {
        this.step = step;
      } else {
        this.step = this.state.length - 2;
      }
    },
    updateQuestionnaire(data, back = false) {
      // we have to do this weird questionnaireId logic because if you go back after finishing the questionnaire
      // then shouldEnterOnboardingQuestionnaire will return false, and we won't know what questionnaire we were on
      const questionnaireId =
        this.storedQuestionnaireId || this.questionnaireId;
      this.storedQuestionnaireId = questionnaireId;
      return this.$store
        .dispatch('questionnaires/update', { data, questionnaireId })
        .then((response) => {
          // we can't modify the state if we are going back because it will mess up the animation which is based on the
          // cards which is based on the current state, this results in this.state not being accurate, but what is posted
          // to the server is accurate, so there's no consequence of keeping the old state in the array until it is replaced
          if (back) return;

          // The first item in state should always be the start so we can set that
          const newState = [{ questionId: 'start'}];

          // Then take the currentState from the response and sort it by timestamp.
          // This will represent that state of the questionnaire up to this point.
          const sortedState = (response.currentState || []).sort((a, b) => a.timestamp - b.timestamp);
          newState.push(...sortedState);

          // If there is a nextQuestion in the response, we push it into newState
          // If there is not a nextQuestion, the user is done and we can push the `completed` questionId into the newState.
          if (response.nextQuestion) {
            newState.push({ questionId: response.nextQuestion });
          } else {
            newState.push({ questionId: 'completed'});
          }

          // The last item in state should always be the end so finally, we add that.
          newState.push({ questionId: 'end'});

          this.state = newState;

          return response;
        });
    },
  },
};
